import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AUTH } from "@/constants/testIds";

export default function ProfilePage() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed");
      setCurrent(""); setNext("");
    } catch (ex) {
      toast.error(ex?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-outfit font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">Profile</h1>
        <p className="text-sm text-slate-600 mt-1">{user?.email}</p>
      </div>

      <div className="glass-card p-6 max-w-lg space-y-3">
        <div className="text-sm text-slate-700">
          Role: <span className="font-medium">{user?.is_super_admin ? "Super admin" : user?.is_admin ? "Admin" : "User"}</span>
        </div>
        <div className="text-sm text-slate-700">2FA: <span className="font-medium">{user?.totp_confirmed ? "Enabled" : "Disabled"}</span></div>
      </div>

      <form onSubmit={change} className="glass-card p-6 max-w-lg space-y-4">
        <div className="font-outfit font-semibold text-slate-900">Change password</div>
        <div>
          <Label>Current password</Label>
          <Input type="password" className="glass-input mt-1" data-testid={AUTH.changePasswordCurrent}
            value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
        <div>
          <Label>New password (min 10 chars)</Label>
          <Input type="password" className="glass-input mt-1" data-testid={AUTH.changePasswordNew}
            value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <Button type="submit" disabled={busy} className="btn-tactile" data-testid={AUTH.changePasswordSubmit}
          style={{ background: "linear-gradient(135deg,#0A84FF,#0069cc)" }}>
          Change password
        </Button>
      </form>
    </div>
  );
}
